<template>
  <div class="wrapper">
    <app-header></app-header>
    <app-side-bar></app-side-bar>

    <div class="content-wrapper">
      <transition
        appear
        enter-class=""
        enter-active-class="animated fadeIn"
        leave-class=""
        leave-active-class=""
      >
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from "../components/header/Header.vue";
import SideBar from "../components/side-bar/SideBar.vue";
import Footer from "../components/Footer.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    appHeader: Header,
    appSideBar: SideBar,
    appFooter: Footer,
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
  },
  watch: {
    $route: "onChangeRoute",
  },
  created() {
    // console.log("MainPage created ", this.loggedInUser);
    if (this.loggedInUser && this.loggedInUser.role) {
      setTimeout(() => {
        this.$store.dispatch("admin/setAllOrgs", this.loggedInUser);
        this.$store.dispatch("partner/setPartners");
        this.updateRoute();
      }, 1000);
    }
  },
  methods: {
    onChangeRoute() {
      // console.log(this.$route.path)
      this.updateRoute();
    },
    updateRoute() {
      let role = this.loggedInUser.role.toLowerCase();
      let currentRoute = this.$route.path;
      if (currentRoute == "/main") {
        this.$router.push("/main/dashboard/" + role);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/MainPage.vue